export default "__VITE_ASSET__BJM_mlol__"